<template >
    <div id="map_gd_list">
        <el-drawer
                title="岗点列表"
                :visible.sync="gdListVisible"
                direction="rtl"
                size="50%">
            <el-row style="margin-bottom: 20px">
                <el-col :span="8">
                    <el-input  @change="changeIndex"
                               placeholder="请输入岗点名称"
                               v-model="searchForm.gdmc"
                               clearable>
                    </el-input>
                </el-col>
                <el-col :span="8">
                    <el-select @change="changeIndex" clearable :disabled="deptdisable"   filterable    v-model="searchForm.bmid" placeholder="请选择大队">
                        <el-option
                                v-for="item in depts"
                                :key="item.bmid"
                                :label="item.bmmc"
                                :value="item.bmid"
                                :disabled="deptdisable">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="8">
                    <el-button type="primary" @click="loadData()">查询</el-button>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-table id="map_table"  v-loading="loading" :data="tableData" border  style="width: 100%">
                        <el-table-column label="名称" prop="gdmc">
                        </el-table-column>
                        <el-table-column  prop="dkjl" label="打卡距离" width="90">
                        </el-table-column>
                        <!--                        <el-table-column  prop="dkrs" label="人数">-->
                        <!--                        </el-table-column>-->
                        <el-table-column  prop="morrs" label="早班人数" width="90">
                        </el-table-column>
                        <el-table-column  prop="aftrs" label="中班人数" width="90">
                        </el-table-column>
                        <el-table-column  prop="evers" label="夜班人数" width="90">
                        </el-table-column>

                        <el-table-column label="操作" >
                            <template slot-scope="scope">
                                <el-button @click="dwClick(scope.row)" type="text" size="mini">定位</el-button>
                                <el-button v-if="isAuth('gangdian:update')" @click="updateClick(scope.row)" type="text" size="mini">修改</el-button>
                                <el-button v-if="isAuth('gangdian:delete')" @click="deClick(scope.$index,scope.row)" type="text" size="mini">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="total, prev, pager, next" :total="total" @current-change="pageUser" style="margin-top: 1rem;"></el-pagination>
                </el-col>
            </el-row>
        </el-drawer>
    </div>
</template>

<script>


    export default {
        data() {
            return {
                gdListVisible: false,
                searchForm: {
                    gdmc: '',
                    bmid: '',
                    page: 1,
                    pagesize: 10
                },
                depts: [],
                total: 0,
                deptdisable: false,
                tableData: [],
                loading: false
            }
        },
        created() {
            this.getDepts()
        },
        methods: {

            init(name) {

                this.gdListVisible = true
                this.$nextTick(() => {
                    if(name) {
                        this.searchForm.gdmc = name
                        this.loadData()
                    }
                })
            },
            getDepts() {
                let that = this;
                this.$request.get('/bjba/kqtj/getFirstMentForUser', {
                    params: {
                        userid: this.$store.getters.username
                    }

                }).then(res => {
                    that.depts = res.data
                    if (this.depts && this.depts[0]) {
                        var zzdyqc = this.$store.getters.user.zzdyqc;
                        if (zzdyqc) {
                            if (this.CONST_MOSTHIGH_DEPTS&&this.CONST_MOSTHIGH_DEPTS.includes&&!this.CONST_MOSTHIGH_DEPTS.includes(zzdyqc)) {
                                var zw = this.$store.getters.user.zw;

                                if (zw) {
                                    if (zw == '01' || zw == '02' || zw == '03') {
                                        this.searchForm.bmid = that.depts[0].bmid
                                        this.deptdisable = true

                                    }

                                }
                            }

                        }

                    }
                    this.loadData();
                })
            },
            loadData() {
                this.$request({
                    method: 'get',
                    url: '/bjba/map/getGdPage',
                    params: this.searchForm
                }).then((response) => {
                    this.loading = false
                    this.tableData = response.data.content
                    this.total = response.data.totalElements
                })
            },
            changeIndex() {
                this.searchForm.page = 1
            },
            pageUser(page) {
                this.searchForm.page = page
                this.loadData()
            },
            dwClick(row) {
                this.gdListVisible = false
                this.$emit('dwClick', row)
            },
            updateClick(row) {
                this.gdListVisible = false
                this.$emit('editClick', row)
            },
            deClick(index, row) {
                let that = this;
                that.$confirm('是否确定删除此岗点信息', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.$request({
                        method: 'get',
                        url: '/bjba/map/deleteGdxx',
                        params: {
                            id: row.gdid
                        }
                    }).then((response) => {
                        this.$message.success("删除成功！");
                        that.loadData();
                        this.gdListVisible = false;
                        this.$emit("loadData")
                    }).catch(err => {
                        alert("删除失败！")
                    })
                }).catch(() => {
                });
            }
        }
    }
</script>

<style lang="scss">
    #map_gd_list .el-drawer.rtl {
        overflow: scroll;
    }
</style>
